/**
 * @desc 报损
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(body: defs.stock.StockOrderLossCmd, options?: any) {
  return updateResponse(
    http(URL + `/stock/losses`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
